import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useButtonsActions } from "../../hooks/useButtonsActions";
import ArrowBackIcon from "../../images/arrow-back.svg";
import ChatIcon from "../../images/attendance.svg";
import Browser from "../../images/browser.svg";
import EmailIcon from "../../images/email.svg";
import SuccessIcon from "../../images/send-ticket-success.svg";
import { api } from "../../services/api";
import { Button } from "../Button";
import { DropzoneFiles } from "../DropzoneFiles";
import { PrivacyPolicy } from "./PrivacyPolicy";

interface Step5Props {
  setFile: (file: any) => void;
  setIsValidCaptcha: (value: boolean) => void;
  file: any;
  isValid: boolean;
  isValidCaptcha: boolean;
  isValidating: boolean;
  isSubmitting: boolean;
  isSubmited: boolean;
  acceptedTerms: boolean;
  handlePrevStep: () => void;
  setAcceptedTerms: (value: boolean) => void;
}

export function Step5({
  setFile,
  setIsValidCaptcha,
  setAcceptedTerms,
  file,
  isValid,
  isValidCaptcha,
  isSubmitting,
  isValidating,
  isSubmited,
  acceptedTerms,
  handlePrevStep,
}: Step5Props) {
  async function validateCaptcha(response: string | null) {
    if (response) {
      const { data } = await api.post("/validate", { userToken: response });

      if (data.success) {
        setIsValidCaptcha(true);
      }
    }
  }

  const { call, sendMail, handleAttendance } = useButtonsActions();

  return !isSubmited ? (
    <div>
      <button className="prevButton" onClick={handlePrevStep}>
        <img src={ArrowBackIcon} alt="Prev Icon" />
        Editar informações
      </button>

      <DropzoneFiles setFile={setFile} />

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "1.62500rem",
        }}
      >
        <ReCAPTCHA
          sitekey="6LcDLDUeAAAAAN_pmBbKYm9e8MfUH4dgoGVFEMxL"
          onChange={validateCaptcha}
          onExpired={() => setIsValidCaptcha(false)}
        />
      </div>

      <PrivacyPolicy
        acceptedTerms={acceptedTerms}
        setAcceptedTerms={setAcceptedTerms}
      />

      <Button
        className="mb-1"
        text="Enviar boleto"
        type="submit"
        disabled={
          (!isValidating && isSubmitting) ||
          !isValid ||
          !file ||
          !isValidCaptcha ||
          !acceptedTerms
        }
        id="modalSubmit"
      >
        <img src={Browser} alt="Phone Icon" />
      </Button>
    </div>
  ) : (
    <div className="successContainer">
      <img src={SuccessIcon} alt="" />

      <h2>Seu boleto foi enviado com sucesso!</h2>

      <p>Fique tranquilo, a gente entra em contato com você.</p>

      <small>Ficou com alguma dúvida?</small>

      <div>
        <button className="button" type="button" onClick={handleAttendance}>
          <img src={ChatIcon} alt="ChatIcon Icon" />
          Atendimento
        </button>

        <button className="button" type="button" onClick={sendMail}>
          <img src={EmailIcon} alt="E-mail Icon" />
          E-mail
        </button>
      </div>
    </div>
  );
}
